import type { TFunction } from "i18next";
import { ApiError, NetworkError } from "@/shared/api/errors";
import { minutesToWait } from "@/shared/lib/time";

/** Maps a failed auth call to a message for the customer. Branches on the stable error code. */
export function authErrorMessage(error: unknown, t: TFunction<["auth", "common"]>): string {
  if (error instanceof NetworkError) return t("common:errors.network");
  if (!(error instanceof ApiError)) return t("common:errors.unexpected");
  switch (error.code) {
    case "identity.phone_invalid":
      return t("auth:errors.phoneInvalid");
    case "identity.otp_resend_too_early":
      return t("auth:errors.tooEarly", { seconds: error.retryAfterSeconds ?? 60 });
    case "identity.otp_too_many_requests":
      return t("auth:errors.tooManyRequests", { minutes: minutesToWait(error.retryAfterSeconds) });
    case "identity.otp_wrong_code":
      return t("auth:errors.wrongCode");
    case "identity.otp_expired":
      return t("auth:errors.codeExpired");
    case "identity.otp_attempts_exceeded":
      return t("auth:errors.attemptsExceeded");
    case "identity.otp_not_requested":
      return t("auth:errors.notRequested");
    default:
      return t("common:errors.unexpected");
  }
}
